export { CarReviewsHubFeature } from './lib/car-reviews-hub'

export { getStaticProps as V2GetStaticProps } from './lib/get-static-props'
export {
  getStaticPathsForPage,
  getStaticPathForMakes,
  getStaticPathForModels,
} from './lib/get-static-paths'
